h<template>
  <div class="product-sort">
    <label class="product-sort__label" v-html="sortLabel"></label>
    <div class="product-sort__tags">
      <button
        v-for="tag in tags"
        class="product-sort__tag"
        @click="selectTag(tag)"
        :class="[
          sortOut.includes(tag) ? 'active' : '',
          sortOut.length > 1 && tag === 'view all' ? 'inactive' : '']">{{tag}}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductSort',
  data () {
    return {
    }
  },
  props: {
    tags: Array,
    sortLabel: String,
  },
  computed: {
    sortOut() {
      return this.$root.$data.state.sort;
    }
  },
  methods: {
    selectTag(tagSort) {
      console.log('selecting a tag');
      console.log(tagSort);
      this.$emit('tagSelected', tagSort);
    },
  },
};
</script>

<style scoped lang="stylus">

@import '../../styles/common.styl'

.product-sort
  margin-bottom 15px
  &__label
    display inline-block
    text-transform uppercase
    margin 10px 15px 0px 0px
    vertical-align top
    +mobile()
      display block
      text-align center
      margin 10px 0px
  &__tags
    display inline-block
    width 80%
    +mobile()
      width 100%
      text-align center
      margin-top 15px
  &__tag
    display inline-block
    text-decoration none
    text-transform uppercase
    padding 10px 20px
    border 1px solid #e4e4e4
    margin 0px 6px
    margin-bottom 10px
    background-color #fff
    &:active,
    &:hover
      border-color $OTSred
      color $OTSred
    &.active
      border-color $OTSred
      color $OTSred
    &.inactive
      border-color #e4e4e4
      color #333
    +mobile()
      padding 10px


</style>



// WEBPACK FOOTER //
// src/components/UIComponents/ProductSort.vue